<template>
  <div>
    <b-modal
      v-model="importModal"
      hide-footer
      size="sm"
      no-close-on-backdrop
      class="pt-8"
      centered
      header-class="p-0"
      body-class="p-2"
      footer-class="d-flex justify-content-center border-0"
      content-class="custom-model-wrap"
    >
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ $translate("import_activities") }}
        </div>
      </template>
      <import-orders-form
        @success="closeImportModal"
        @cancel="closeImportModal"
      />
    </b-modal>

    <div>
      <b-col>
        <order-table
          :title="$translate('users')"
          @add="addModal = true"
          @import="importModal = true"
          ref="table"
          :import-counter="importCounter"
        >
        </order-table>
      </b-col>
    </div>
  </div>
</template>

<script>
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";

import OrderTable from "./OrderTable";
import ImportOrdersForm from "./ImportOrdersForm";

export default {
  name: "orders",
  mixins: [popupMixins, permissionsMixins],
  components: {
    OrderTable,
    ImportOrdersForm,
  },
  data: () => {
    return {
      divWidth: null,
      divLeft: null,
      activeButton: null,
      addModal: false,
      importModal: false,
      importCounter: 0,
    };
  },
  computed: {
    componentName() {
      return this.$translate("activity");
    },
  },
  async created() {
    console.log("fetching users");
    this.$store.commit("locations/SET_LOCATION", {});
    await Promise.all([this.$store.dispatch("company/fetch")]);
  },
  methods: {
    orderCreated() {
      this.addModal = false;
      // this.$refs.table.doSearch(true);
      this.genericToast(
        this.componentName,
        this.$translate("created"),
        "success",
        `${this.componentName} ${this.$translate("create_alert")}`
      );
    },
    closeImportModal() {
      this.importModal = false;
      this.importCounter++;
    },
  },
};
</script>
